import TrackingService from "./tracking_service.js";
import ComboPromoButton from "./combopromo_button.js";
import "../scss/all.scss";

window.o_p13n_combopromo = window.o_p13n_combopromo || {};
window.o_p13n_combopromo.api = new ComboPromoButton();
window.o_p13n_combopromo.tracking = new TrackingService();
